import React from "react";
import InnerHTML from "dangerously-set-html-content";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import { isMiniSize, debounce } from "@/utils";

class VideoSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      html: "",
    };

    this.resizeDebounce = debounce(this.resize);
  }

  componentDidMount() {
    this.addVideoJsToBody();
    this.resize();
    window.addEventListener("resize", this.resizeDebounce);
  }

  componentWillUnmount() {
    this.removeVideoJsFromBody();
    window.removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }
  addVideoJsToBody = () => {
    if(!document.getElementById('videjs-style-disable')){
      var scriptElement =document.createElement('script');
      scriptElement.innerHTML = "window.VIDEOJS_NO_DYNAMIC_STYLE = true;";
      scriptElement.id = "videjs-style-disable";
      document.body.appendChild(scriptElement);
    }
    if(!document.getElementById('videjs-script')){
      var scriptElement =document.createElement('script');
      scriptElement.src = "https://vjs.zencdn.net/8.12.0/video.min.js";
      scriptElement.id = "videjs-script";
      document.body.appendChild(scriptElement);
    }
  }
  removeVideoJsFromBody = () => {
    var scriptElement = document.getElementById('videjs-style-disable');
    if(scriptElement){
      scriptElement.parentNode.removeChild(scriptElement);
    }
    scriptElement = document.getElementById('videjs-script');
    if(scriptElement){
      scriptElement.parentNode.removeChild(scriptElement);
    }
  }
  resize = () => {
    const { t, fields, authentication } = this.props;
    const config = require("../../temp/config");
    const mobile = isMiniSize();
    var padding = mobile ? 32 : 56;
    var width =
      parseInt(t("video_width")) > 760 ? 760 : parseInt(t("video_width"));
    var content = document.getElementById("content-main");

    if (content && content.offsetWidth <= 760) {
      var offsetWidth = content.offsetWidth - padding;
      if (width > offsetWidth) {
        width = offsetWidth;
      }
    }

    this.setState({
      html: `<div style="max-width: ${width}px;"><video-js data-account="${t(
        "video_data_account"
      )}" data-player="${t(
        "video_data_player"
      )}" data-embed="default" controls="" data-video-id="${
        fields?.videoId?.value
      }" data-playlist-id="" data-application-id="" width="${
        mobile ? "" : width
      }" height="${
        mobile ? "" : t("video_height")
      }"></video-js></div>
      <script>
        var isFirstVideoSection = true;
        var havePlayedVideos = [];

        // プレイヤーへのonPlay処理割り当て
        function initializePlayer(bcScript){
          var isHideHtml = bcScript.closest('#content-main-all-detail');
          if(isFirstVideoSection && isHideHtml == null){
            for (x = 0; x < Object.keys(bc.videojs.players).length; x++) {
              var setPlayer = Object.keys(bc.videojs.players)[x];
              var player = videojs.getPlayer(setPlayer);
              if(player){
                player.ready(function() {
                  myPlayer = this;
                  myPlayer.on("play", onPlay);
                });
              }
            }
            isFirstVideoSection = false;
          }
        }
        // 動画再生時処理
        function onPlay(e){
          var targetVideoNode = e.target;
          var videoId = targetVideoNode.getAttribute('data-video-id');
          if(!havePlayedVideos[videoId]){
            havePlayedVideos[videoId] = true;
            GetTimeApi(videoId);            
          }
        }
        // システム時間の取得（IF1032）
        function GetTimeApi(videoId){        
          const time = new Date().getTime();
          const apiKey = encodeURI('${config.sitecoreApiKey}');
          fetch('/sitecore/api/trinity/NoLogin/GetTime?sc_apikey='+ apiKey + '&_t=' + time)
          .then(response => {
            return response.json();
          })
          .then(data => {
            const currentTime = data.data;
            BrightcoveLogEntryApi(currentTime, videoId);
          })
          .catch(error =>{
            console.error("error: " + error.message);
          });
        }
        // BrightCoveログ登録処理（TASp0017）
        function BrightcoveLogEntryApi(currentTime, videoId){
          var params = {
            method:'POST',
            headers:{
              'Content-Type': 'application/json',
              'Authorization':'Bearer ${authentication?.token}',
            },
            body:JSON.stringify({
                playerId:'${t("video_data_player")}',
                videoId:videoId,
                viewerId:'${authentication?.userIdentifier}',
                viewDate: currentTime})
          }
          fetch('/api/v1/brightcove-log-entry?accountId=${authentication?.accountId}&accessToken=${authentication?.token}',params);
        }
      </script>
      <script src="https://players.brightcove.net/${t(
        "video_data_account"
      )}/${t("video_data_player")}_default/index.min.js" onload="initializePlayer(this)"></script>`,
    });
  };

  render() {
    const { html } = this.state;
    return <InnerHTML className="video-section-container" html={html} />;
  }
}

const mapStateToProps = (state) => {
  return {
    authentication: state?.user?.authentication,
  };
};

export default connect(mapStateToProps)(withTranslation()(VideoSection));
